import createReducer from '../../reducers/utils/createReducer';
import * as c from './types';

const initialState = {
  data: [],
  isLoading: false,
  error: null
};

export default createReducer(initialState, {
  [c.GET_DOWNTIMES_REQUEST]: (state) => ({
    ...state,
    error: null,
    isLoading: true
  }),
  [c.GET_DOWNTIMES_SUCCESS]: (state, { payload }) => ({
    ...state,
    data: payload,
    isLoading: false
  }),
  [c.GET_DOWNTIMES_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isLoading: false
  }),

  // Create or Update Custom
  [c.STORE_DOWN_TIMES_REQUEST]: (state) => ({
    ...state,
    error: null,
    isLoading: true
  }),
  [c.STORE_DOWN_TIMES_SUCCESS]: (state, { payload }) => ({
    ...state,
    items: payload,
    isLoading: false
  }),
  [c.STORE_DOWN_TIMES_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isLoading: false
  })
});
